"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VehicleToDataTransfomer = void 0;
const Vehicle_1 = require("../Model/Vehicle");
const RegistrationStatus_1 = require("../Model/RegistrationStatus");
const VehicleHistory_1 = require("../Model/VehicleHistory");
const configs_1 = require("../configs/configs");
/**
 * Transforms the inputs of the form into a customer object.
 */
class VehicleToDataTransfomer {
    to(vehicle) {
        const data = {
            vrm: vehicle.getVrm(),
            mileage: vehicle.getMileage(),
            registrationLocation: vehicle.getRegistrationLocation()
        };
        const setters = {
            modelCode: vehicle.getModelCode,
            variantCode: vehicle.getModelVariantCode
        };
        Object.entries(setters).forEach(([prop, setter]) => {
            this.setIfNotUndefined(data, prop, vehicle, setter);
        });
        return data;
    }
    from(data) {
        var _a, _b, _c;
        const vehicle = new Vehicle_1.Vehicle();
        const vehicleHistory = new VehicleHistory_1.default()
            .setStolen(((_a = data.vehicleHistory) === null || _a === void 0 ? void 0 : _a.stolen) || false)
            .setWritenOff(((_b = data.vehicleHistory) === null || _b === void 0 ? void 0 : _b.hasWritOfffHistory) || false);
        let registrationStatus = (_c = data.vehicleHistory) === null || _c === void 0 ? void 0 : _c.registrationStatus;
        let registrationStatusModel = null;
        if (registrationStatus && registrationStatus.registrationLocation) {
            registrationStatusModel = new RegistrationStatus_1.default()
                .setRegistered(data.registered)
                .setRegistrationLocationCode(registrationStatus.registrationLocation);
            const locationLabel = configs_1.configs.addressState.find((loc) => loc.id == registrationStatusModel.getRegistrationLocationCode());
            if (locationLabel) {
                registrationStatusModel.setRegistrationLocation(locationLabel.label);
                vehicle.setRegistrationLocation(locationLabel.label);
            }
            if (registrationStatus && registrationStatus.expiryDate) {
                registrationStatusModel.setExpiryDate(registrationStatus.expiryDate);
            }
            vehicleHistory.setRegistrationStatus(registrationStatusModel);
        }
        vehicle
            .setBodyType(data.bodyType)
            .setEngineSize(data.engineSize)
            .setFuelType(data.fuelType)
            .setId(data.id)
            .setImage(data.image)
            .setManufacturer(data.manufacturer)
            .setManufacturerCode(data.manufacturerCode)
            .setModel(data.model)
            .setModelCode(data.modelCode)
            .setModelDerivative(data.modelDerivative)
            .setModelDerivativeCode(data.modelDerivativeCode)
            .setModelVariant(data.modelVariant)
            .setModelVariantCode(data.modelVariantCode)
            .setRegistrationDate(data.registrationDate)
            .setRegistrationYear(data.registrationYear)
            .setTransmission(data.transmission)
            .setTrim(data.trim)
            .setVrm(data.vrm)
            .setCondition(data.condition)
            .setType(data.vehicleType)
            .setBuildYearCode(data.manufactureYearCode)
            .setBuildYear(data.manufactureYear)
            .setFuelTypeCode(data.fuelTypeCode)
            .setTransmissionCode(data.transmissionCode);
        if (vehicleHistory) {
            vehicle.setVehicleHistory(vehicleHistory);
        }
        return vehicle;
    }
    setIfNotUndefined(data, prop, vehicle, getter) {
        if (getter.call(vehicle)) {
            data[prop] = getter.call(vehicle);
        }
    }
}
exports.VehicleToDataTransfomer = VehicleToDataTransfomer;
